export default __webpack_public_path__ + "static/media/humanely-white.0a7b323b.png";